import React, { useState } from 'react';
import { Alert, Button, Input, Modal, Typography } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { IGenerateTokenResponse } from '../../../../services/aiChat/agentToken.service';

const { Text } = Typography;

interface TokenCreatedModalProps {
  data: IGenerateTokenResponse | null;
  onDone: () => void;
}

const TokenCreatedModal: React.FC<TokenCreatedModalProps> = ({ data, onDone }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!data?.token) return;
    try {
      await navigator.clipboard.writeText(data.token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      // Fallback for browsers that block clipboard API
      const el = document.createElement('textarea');
      el.value = data.token;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  return (
    <Modal
      wrapClassName="custom-modal"
      title="Token Generated"
      centered
      visible={!!data}
      footer={null}
      closable={false}
      maskClosable={false}
      width={560}
    >
      {data && (
        <>
          <div className="token-created-meta">
            <div className="token-created-meta-row">
              <Text type="secondary">Label</Text>
              <Text strong>{data.label}</Text>
            </div>
            <div className="token-created-meta-row">
              <Text type="secondary">Email</Text>
              <Text>{data.email}</Text>
            </div>
          </div>

          <Alert
            type="warning"
            showIcon
            className="token-warning-banner"
            message={
              <span>
                <strong>This token will not be shown again.</strong> Copy it now and store it
                securely. If you lose it, you must revoke this token and generate a new one.
              </span>
            }
          />

          <div className="token-value-block">
            <Input.TextArea
              value={data.token}
              readOnly
              autoSize={{ minRows: 3, maxRows: 6 }}
              className="token-textarea"
            />
            <Button
              icon={copied ? <CheckOutlined /> : <CopyOutlined />}
              type={copied ? 'default' : 'primary'}
              onClick={handleCopy}
              className="token-copy-btn"
            >
              {copied ? 'Copied!' : 'Copy to Clipboard'}
            </Button>
          </div>

          <div className="btns-block modal-footer">
            <Button type="primary" onClick={onDone}>
              Done
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default TokenCreatedModal;
